import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-table-tooltip',
  templateUrl: './table-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableTooltipComponent {
  text = '';
  visible = false;
  x = 0;
  y = 0;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  show(event: Event, text: string): void {
    const target = event.currentTarget;
    if (!text || !(target instanceof HTMLElement)) return;

    const rect = target.getBoundingClientRect();
    this.text = text;
    this.x = rect.left + rect.width / 2;
    this.y = rect.top;
    this.visible = true;
    this.changeDetectorRef.markForCheck();
  }

  hide(): void {
    if (!this.visible) return;
    this.visible = false;
    this.changeDetectorRef.markForCheck();
  }

  @HostListener('document:keydown.escape')
  @HostListener('window:resize')
  hideOnViewportChange(): void {
    this.hide();
  }
}
